module.exports = __webpack_public_path__ + "img/图片4.1af14cf7.png";